import React from 'react';
import { HeroSection } from './HeroSection';
import { ProblemSection } from './ProblemSection';
import { MechanismSection } from './MechanismSection';
import { ValueStack } from './ValueStack';
import { AudienceSection } from './AudienceSection';
import { HowItWorks } from './HowItWorks';
import { ProofSection } from './ProofSection';
import { FAQSection } from './FAQSection';
import { OfferSection } from './OfferSection';
import { Footer } from './Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-botanical-ivory font-lora selection:bg-botanical-gold/30 selection:text-botanical-forest" data-id="element-176">
      <HeroSection data-id="element-177" />
      <ProblemSection data-id="element-178" />
      <MechanismSection data-id="element-179" />
      <ValueStack data-id="element-180" />
      <AudienceSection data-id="element-181" />
      <HowItWorks data-id="element-182" />
      <ProofSection data-id="element-183" />
      <FAQSection data-id="element-184" />
      <OfferSection data-id="element-185" />

      <Footer data-id="element-186" />
    </main>;
}